import { usePathname } from 'next/navigation';

const usePathContains = () => {
  const pathname = usePathname();

  const checkPathHas = (key: string) => {
    return pathname?.includes(key);
  };

  return {
    checkPathHas
  };
};

export default usePathContains;
